module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('loading', {
    attrs: {
      "show": _vm.loading.status,
      "text": _vm.loading.text,
      "position": "absolute"
    }
  }), _vm._v(" "), _c('toast', {
    attrs: {
      "type": "text",
      "time": _vm.toast.time
    },
    model: {
      value: (_vm.toast.show),
      callback: function($$v) {
        _vm.$set(_vm.toast, "show", $$v)
      },
      expression: "toast.show"
    }
  }, [_vm._v(_vm._s(_vm.toast.text))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": 'vux-pop-' + (_vm.direction === 'forward' ? 'in' : 'out')
    }
  }, [_c('router-view', {
    staticClass: "router-view"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-d0e1f974"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/regexp-replace-loader?{"match":{"pattern":"replacing_api","flags":"g"},"replaceWith":"/api/v1"}!./node_modules/regexp-replace-loader?{"match":{"pattern":"replacing_auth","flags":"g"},"replaceWith":"/auth/weixin"}!./node_modules/regexp-replace-loader?{"match":{"pattern":"replacing_env","flags":"g"},"replaceWith":"production"}!./node_modules/regexp-replace-loader?{"match":{"pattern":"replacing_version","flags":"g"},"replaceWith":"1.1.3"}!./src/App.vue
// module id = iWea
// module chunks = 1